import IWelcomeSlideData from '@app/types/data/slides/IWelcomeSlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import AbstractSlideTransform from './AbstractSlideTransform';

/**
 * Transform for 002-WelcomeSlide
 * TODO: background image as fallback for thumbnail once integrated
 */
export default class WelcomeSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'WelcomeSlide';

	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IWelcomeSlideData> {
		const data: IWelcomeSlideData = {
			id: slide.id,
			label: slide.fields.label,
			thumbnail: this.extractThumbnail('Welcome', slide, 'image'),
			overline: presentationSettings.welcomeSettings.overline || slide.fields.overline,
			headline: presentationSettings.welcomeSettings.headline || slide.fields.headline,
			copy: (
				presentationSettings.welcomeSettings.copy || this.transformRichtext(slide.fields.copy, presentationSettings)
			).replace(/\n/g, '<br>'),
			showPartnerLogos: presentationSettings.welcomeSettings.showPartnerLogos
		};

		if (slide.fields.videoLoop && slide.fields.videoLoop.fields.asset) {
			data.video = this.transformVideoAsset(slide.fields.videoLoop.fields.asset);
		}

		return data;
	}
}
